import React from 'react';
import './sec2-p2.css'
import Cardsec2p2 from '../components/common/card-sec2-p2';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


gsap.registerPlugin(ScrollTrigger);

const Sec2p2 = ({ selectedCategory, searchTerm }) => {
const [exhbition, setexhbition]= useState([]);
const [headers, setheaders]= useState([]);
const containerRef = useRef(null);

useEffect(() => {
  const getexhbition = async () => {

    const { data: eventData } = await supabase
      .from('exbition_event').select('id').eq('status', 'ongoing').single();
    if (!eventData) return;


    const { data, error } = await supabase
      .from('exhibitors')
      .select(`
       id,
        logo,
        img_alt,
          exhibitor_name,

        booth_number,
        description,
         exhibitor_categories (
          categories:category_id (  category_name )),

        exbition_event_exhibitors!inner (
          exhibitor_id, event_exhibitors_id )`)
      .eq('exbition_event_exhibitors.event_exhibitors_id', eventData.id); 

    if (error) { console.log(error); setexhbition([]); return; }
    setexhbition(data || []);
  };

  getexhbition();
}, []);








useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setheaders(res.data);
}
getheaders();
}, []);





const filteredExhibitors = exhbition.filter((item) =>
  (!selectedCategory ||
    item.exhibitor_categories?.some(
      (c) => c.categories?.category_name === selectedCategory
    )) &&
  item.exhibitor_name?.toLowerCase().includes(searchTerm.toLowerCase())
);



useEffect(() => {
  if (!containerRef.current) return;

  const cards = containerRef.current.children;

  gsap.fromTo(
    cards,
    { y: 100, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: 'power2.out',
      stagger: 0.2,
      scrollTrigger: {
        trigger: containerRef.current,
        start: 'top 85%',
      }
    }
  );
}, [filteredExhibitors]);




console.log("SELECTED CATEGORY:", selectedCategory);
    return ( 
        <section className='sec2-p2 '>
            <section className='container-cards-sec2-p2 '>
                    <section className='big-cont-sec2-p2'>
                        <article className='main-cont-sec2-p2'>
                                <h1 className='headerr-sec2-p2'>{headers?.[9]?.header}</h1>


                        <article className='container2-cards-sec2-p2'   ref={containerRef}>
                                 {filteredExhibitors?.map((item) => (
                                <Cardsec2p2
                                key={item.id}
                                img={item.logo}
                                alt={item.img_alt}
                                title={item.exhibitor_name}
                                para={item.description}
                            category={
                                item.exhibitor_categories
                                    ?.map((c) => c.categories?.category_name)
                                    .join(', ')
                                }
                                booth={item.booth_number}
                                />
                            ))}

                        </article>


                        </article>
                    </section>
            </section>
        </section>
     );
}
 
export default Sec2p2;